import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { ButtonModule } from '@sb/library/button';
import { FormFieldModule } from '@sb/library/form-field';
import { IconModule } from '@sb/library/icon';
import { LocalizationModule } from '@sb/library/localization';
import { MbscDatepickerModule } from '@mobiscroll/angular';
import { ChipButtonComponent } from './chip-button.component';
import { ChipDateRangeSelectBottomSheetComponent } from './date-range-select/bottom-sheet/chip-date-range-select-bottom-sheet.component';
import { ChipDateRangeSelectComponent } from './date-range-select/chip-date-range-select.component';
import { ChipDateRangeSelectPanelComponent } from './date-range-select/panel/chip-date-range-select-panel.component';
import { ChipButtonMultiSelectComponent } from './multi-select/chip-button-multi-select.component';
import { ChipMultiSelectBottomSheetComponent } from './multi-select/multi-select-bottom-sheet/chip-multi-select-bottom-sheet.component';
import { ChipButtonSelectComponent } from './select/chip-button-select.component';
import { ChipButtonSelectItemComponent } from './select/item/chip-button-select-item.component';
import { ChipButtonSelectBottomSheetComponent } from './select/select-bottom-sheet/chip-button-select-bottom-sheet.component';
import { ChipButtonTabsComponent } from './tabs/chip-button-tabs.component';
import { ChipButtonTabsItemComponent } from './tabs/item/chip-button-tabs-item.component';
import { ChipTimeRangePickerBottomSheetComponent } from './time-range-picker/bottom-sheet/chip-time-range-picker-bottom-sheet.component';
import { ChipTimeRangePickerComponent } from './time-range-picker/chip-time-range-picker.component';
import { ChipTimeRangePickerPanelComponent } from './time-range-picker/panel/chip-time-range-picker-panel.component';

@NgModule({
    declarations: [
        ChipButtonComponent,
        ChipButtonSelectComponent,
        ChipButtonSelectItemComponent,
        ChipButtonTabsItemComponent,
        ChipButtonTabsComponent,
        ChipButtonSelectBottomSheetComponent,
        ChipDateRangeSelectComponent,
        ChipDateRangeSelectPanelComponent,
        ChipDateRangeSelectBottomSheetComponent,
        ChipTimeRangePickerComponent,
        ChipTimeRangePickerPanelComponent,
        ChipTimeRangePickerBottomSheetComponent,
        ChipButtonMultiSelectComponent,
        ChipMultiSelectBottomSheetComponent
    ],
    imports: [
        CommonModule,
        MatOptionModule,
        MatSelectModule,
        IconModule,
        MatChipsModule,
        MatBottomSheetModule,
        MatListModule,
        MbscDatepickerModule,
        MatMenuModule,
        ButtonModule,
        LocalizationModule,
        FormFieldModule
    ],
    exports: [
        ChipButtonComponent,
        ChipButtonSelectComponent,
        ChipButtonSelectItemComponent,
        ChipButtonTabsComponent,
        ChipButtonTabsItemComponent,
        ChipButtonSelectBottomSheetComponent,
        ChipDateRangeSelectComponent,
        ChipDateRangeSelectPanelComponent,
        ChipDateRangeSelectBottomSheetComponent,
        ChipTimeRangePickerComponent,
        ChipTimeRangePickerPanelComponent,
        ChipTimeRangePickerBottomSheetComponent,
        ChipButtonMultiSelectComponent,
        ChipMultiSelectBottomSheetComponent
    ]
})
export class ChipButtonModule { }
